import { createPageTitle } from '@legalzoom/my-account-core';

export const PageTitles = {
  SignIn: createPageTitle('Sign in'),
} as const;

enum LoginActions {
  LOGIN = 'login',
  CREATE_ACCOUNT = 'create_account',
  ENROLL = 'enroll',
  SEND_CODE = 'send_code',
  VERIFY_CODE = 'verify_code',
  FORGOT_PASSWORD = 'forgot_password',
  SELF_VERIFICATION = 'self_verification',
  IDENTITY_VERIFIED = 'identity_verified',
  STEP_UP = 'step_up',
  POLL_STRIPE_STATUS = 'poll_stripe_status',
  FALLBACK = 'mfa_fallback',
  USER_SELECTED_DEVICE = 'user_selected_device',
  TO_SELECT_DEVICE = 'to_select_device',
  EDIT_MFA_ENROLLMENT = 'edit_mfa_enrollment',
  SELECT_DEVICE = 'select_device',
}

enum FeatureFlagService {
  LAUNCHDARKLYSERVICE = 'launchdarkly',
}

enum LoginUIs {
  FALLBACK = 'mfaFallback',
  ENTER_CODE = 'enterCode',
  ADD_ENROLLMENT = 'addTelephone',
  SELECT_DEVICE = 'select_device',
}

enum IdentityVerificationStatuses {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  FAILURE = 'FAILURE',
}

enum LoginUIVariations {
  DEFAULT = 'DEFAULT',
  BOIR = 'BOIR',
  BOOKS = 'BOOKS',
  ESIGNATURE = 'ESIGNATURE',
  TAX = 'TAX',
  TEMPLATES = 'TEMPLATES',
  VIRTUAL_MAIL = 'VIRTUAL_MAIL',
  PRENUP = 'PRENUP',
  EP = 'EP',
  LOGO_ONLY = 'LOGO_ONLY',
}

const STRIPE_COOKIE = 'LZStripeVerificationStatus';

export {
  LoginUIs,
  LoginActions,
  FeatureFlagService,
  IdentityVerificationStatuses,
  LoginUIVariations,
  STRIPE_COOKIE,
};
